import React from 'react';
import { endpoint } from '../constant/endpoint';
const url = endpoint + '/swagger';

export default function ApiInquire() {
	return (
		<div
			style={{
				height: '100%',
			}}
		>
			<iframe
				title="swagger"
				src={url}
				style={{
					width: '100%',
					height: '100%',
					overflow: 'hidden',
				}}
				height="100%"
				width="100%"
				frameBorder="0"
			></iframe>
		</div>
	);
}
